import styles from "./AssignNextTaskConfirmation.module.css";
import ModalView from "@modals/modalview/ModalView";
import confirmationIcon from "@assets/icons/confirmation-icon.svg";
import closeIcon from "@assets/icons/close-icon.svg";
import { useShortcut } from "@hooks/useShortCut";

interface AssignNextTaskConfirmationProps {
  isOpen: boolean;
  onAssignNextTask: () => void;
  onSubmitAndGoBack: () => void;
  onClose: () => void;
  isSaving?:boolean;
}

function AssignNextTaskConfirmation({
  isOpen,
  onAssignNextTask,
  onSubmitAndGoBack,
  onClose,
  isSaving
}: AssignNextTaskConfirmationProps) {
  useShortcut("Enter",onAssignNextTask);
  useShortcut("Escape",onClose);
  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.closeHeader}>
          <button className={styles.closeBtn} title="Esc" onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>
        <img
          src={confirmationIcon}
          className={styles.confirmationIcon}
          alt="Confirmation"
        />
        <div className={styles.content}>
          <div className={styles.textContent}>
            <h2 className={styles.heading}>Confirm Task Assignment</h2>
            <p className={styles.description}>
              Would you like to continue with the next task or return to your
              dashboard?
            </p>
          </div>
          <div className={styles.btnContainer}>
            <button
              className={styles.submitAndGoBackBtn}
              onClick={onSubmitAndGoBack}
              disabled={isSaving}
            >
              submit and go back
            </button>
            <button title="Enter"
              className={styles.assignNextTaskBtn}
              onClick={onAssignNextTask}
              disabled={isSaving}
            >
              Assign Next Task
            </button>
          </div>
        </div>
      </div>
    </ModalView>
  );
}

export default AssignNextTaskConfirmation;
